<script setup lang="ts">
import { computed } from 'vue'
import { storeToRefs } from 'pinia'

import { useConfigStore } from '../../stores/config'

const props = defineProps<{
  dateTime: string
}>()

const { rsConfig } = storeToRefs(useConfigStore())

const displayDate = computed(() => {
  if (props.dateTime && props.dateTime !== '') {
    const displayDate = new Date(props.dateTime)
    let options: Intl.DateTimeFormatOptions = {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      timeZone: 'Europe/Berlin'
    }
    let clockSuffix = ''

    if (rsConfig.value.authorHeaderDisplayDateFormat === 'DD.MM.YYYY, HH:mm') {
      options = { ...options, hour: '2-digit', minute: '2-digit' }
      clockSuffix = ' Uhr'
    }

    return new Intl.DateTimeFormat('de-DE', options).format(displayDate) + clockSuffix
  }

  return ''
})

const localDate = computed(() => {
  if (props.dateTime && props.dateTime !== '') {
    const dateZulu = new Date(props.dateTime)
    return dateZulu.toISOString()
  }
  return ''
})
</script>

<template>
  <!-- // TODO: displayDate integration in datetime Attribute as value and as content in configurable output format -->
  <time :datetime="localDate"
        class="bx-content__publish-date">
    {{ displayDate }}
  </time>
</template>
